export const PERMISSOES_RESTRICOES = {
	salvar: "salvar.permissao.grupo.usuario",
	criar: "inserir.grupo.usuario",
	duplicar: "clonar.grupo.usuario",
	editar: "atualizar.grupo.usuario",
	excluir: "excluir.grupo.usuario",
} as const;
